import { memo } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useBlindStore } from '../../store/blind-store';
import './BlindPeekSummary.css';

/**
 * Quante volte si è sbirciato, a partita finita. Non compare fuori dalle partite alla
 * cieca — chi non ha giocato bendato non ha niente da leggere qui.
 *
 * Il conto è privato: non viaggia al server e l'avversario non lo vede. È un rendiconto
 * con sé stessi, che è l'unico modo in cui può funzionare — nessun controllo lato client
 * potrebbe distinguere una sbirciata da uno screenshot.
 */
export const BlindPeekSummary = memo(function BlindPeekSummary({ blind }: { blind: boolean }) {
  const { t } = useTranslation();
  const peekCount = useBlindStore((s) => s.peekCount);
  if (!blind) return null;

  return (
    <p className="blind-peek-summary" data-testid="blind-peek-summary" data-peek-count={peekCount}>
      {peekCount === 0
        ? <><EyeOff size={16} aria-hidden="true" />{t('game.blind.noPeeks')}</>
        : <><Eye size={16} aria-hidden="true" />{t('game.blind.peeks', { count: peekCount })}</>}
    </p>
  );
});

export default BlindPeekSummary;
